import React from 'react';

import { Link } from 'react-router-dom';

import modal from 'Demora/modals/modal';

class AwardExplanation extends React.Component {
	closeModal() {
		modal.close('show_awards');
	}

	render() {
		return (
			<div>
				At the end of every month we calculate the final position of every one
				in the league.
				<br />
				<br />
				The top 10 members on the league are awarded the Diamond club status,
				the next 20 are awarded gold, the next 30 silver and the next 40 bronze.
				So everyone in the top 100 will receive an award.
				<br />
				<br />
				The awards are given as recognition of a members hard work and you'll
				see the award on the members profile page.
				<br />
				<br />
				<h5>
					<b>Diamond Club</b>
				</h5>
				Everyone who earns their way into the Diamond Club can always be seen on
				the{' '}
				<Link to='/home/socialize/diamondClub' onClick={this.closeModal}>
					Diamond Club Page
				</Link>
				.
				<br />
				<br />
			</div>
		);
	}
}

export default AwardExplanation;
